var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8598_11933)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.83986 2.07622V1.04095C8.83986 0.951221 8.73674 0.901668 8.6671 0.956578L2.6296 5.6722C2.5783 5.7121 2.53679 5.76318 2.50824 5.82155C2.47969 5.87993 2.46484 5.94405 2.46484 6.00903C2.46484 6.07402 2.47969 6.13814 2.50824 6.19652C2.53679 6.25489 2.5783 6.30597 2.6296 6.34586L8.6671 11.0615C8.73808 11.1164 8.83986 11.0668 8.83986 10.9771V9.94185C8.83986 9.87622 8.80906 9.81328 8.75817 9.7731L3.93674 6.0097L8.75817 2.24497C8.80906 2.20479 8.83986 2.14185 8.83986 2.07622Z",
    fill: "black",
    fillOpacity: 0.85
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8598_11933"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.00976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/ArrowLeft.047d0bbe89f375095992125b214036a5.svg";
export { ForwardRef as ReactComponent };